import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const AppMenu = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div style={{ display: 'flex', gap: 8 }}>
      <Button color="inherit" onClick={() => navigate('/error-tracker', { replace: true })}>
        {t('common.errorsTrackerTool')}
      </Button>
      <Button color="inherit" onClick={() => navigate('/dead-letter', { replace: true })}>
        {t('menu.deadLetters')}
      </Button>
      <Button color="inherit" onClick={() => navigate('/key-vault', { replace: true })}>
        {t('keyVault.toolName')}
      </Button>
      <Button color="inherit" onClick={() => navigate('/anonymizer', { replace: true })}>
        {t('anonymizer.toolName')}
      </Button>
      <Button color="inherit" onClick={() => navigate('/command', { replace: true })}>
        {t('menu.command')}
      </Button>
      <Button color="inherit" onClick={() => navigate('/investigation', { replace: true })}>
        {t('investigation.toolName')}
      </Button>
      <Button color="inherit" onClick={() => navigate('/release-check', { replace: true })}>
        {t('releaseCheck.title', 'Release Checklist')}
      </Button>
    </div>
  )
}

export default AppMenu
